import React, { useEffect } from "react";
import Statistics from "../../components/homePage/Statistics";
import NewOrder from "../../components/homePage/NewOrder";
import { useStateContext } from "../../context/AdminDashboard/HomeContext";
import Navbar from "../../components/main/Navbar";
import toast, { Toaster } from "react-hot-toast";
import Loading from '../../components/atoms/Loading';

const Home = () => {
  const { getdata, isPageLoaded } = useStateContext();

  // Set the document title and fetch data on component mount
  useEffect(() => {
    document.title = "پـیـشـخـــــوان";
    getdata();
  }, []);

  // Render a loading component if the page is not yet loaded
  if (!isPageLoaded) {
    return <Loading height={"h-100"} />;
  }

  // Render the home page components once the page is loaded
  return (
    <>
      <Navbar titles={["پـیـشـخـــــوان"]} />
      <Statistics />
      <div className="flex flex-row mr-7.5px ml-7.5px justify-between pb-7.5px" dir="rtl">
        {/* 
          Uncomment the components below as needed.
          <NewOrder />
          <NewMassage />
        */}
        <Toaster />
      </div>
    </>
  );
};

export default Home;